import type { RemoveElementGroupFromPlan } from "./types";

export const removeElementGroupFromPlan: RemoveElementGroupFromPlan = ({
  plan,
  groupLabel,
}) => {
  const byGroupId = { ...plan.groupedElements.byGroupId };
  delete byGroupId[groupLabel];

  const groupIds = plan.groupedElements.groupIds.filter(
    (id) => id !== groupLabel,
  );

  const groupMeta = Object.fromEntries(
    Object.entries(plan.groupMeta).filter(([key]) => key !== groupLabel),
  );

  return {
    ...plan,
    groupedElements: {
      ...plan.groupedElements,
      byGroupId,
      groupIds,
    },
    groupMeta,
  };
};
